module.exports = __webpack_public_path__ + "img/legacy_4.74cb1362.jpg";